<script setup>
import { t } from "@/controllerLK/AvalLocalization";
import TrashIcon from "@/components/Icons/TrashIcon.vue";
import PencilThinIcon from "@/components/Icons/PencilThinIcon.vue";
import { onMounted, ref, defineProps, defineEmits } from "vue";
import EyeIcon from "@/components/Icons/EyeIcon.vue";

const props = defineProps({
  coords: {
    type: Object,
    required: true,
  },
  isFixedRubric: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    required: true,
    validator: (value) => value.includes("rubrics") || value.includes("blocks")
  }
});

const emit = defineEmits(["edit", "delete", "close", "addToMonitoring"]);

const menuRef = ref(null);

onMounted(() => {
  if (menuRef.value) {
    const menu = menuRef.value;
    const menuRect = menu.getBoundingClientRect();
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    let top = parseFloat(props.coords.top);
    let left = parseFloat(props.coords.left);

    if (left + menuRect.width > viewport.width) {
      left = viewport.width - menuRect.width - 10;
    }

    if (top + menuRect.height > viewport.height) {
      top = top - menuRect.height - 10;
    }

    left = Math.max(10, left);
    top = Math.max(10, top);

    menu.style.top = top + "px";
    menu.style.left = left + "px";
  }
});

const openEditPopup = () => {
  emit("edit");
};

const openDeletePopup = () => {
  emit("delete");
};

const closeMenu = () => {
  emit("close");
};

// Событие постановки на мониторинг
const addToMonitoring = () => {
  emit("addToMonitoring");
};
</script>

<template>
  <div
    class="switcher-menu__overlay"
    @click="closeMenu"
  >
    <ul
      ref="menuRef"
      class="switcher-menu__list"
      @click.stop
    >
      <ListItem
        item="edit"
        @click.stop="openEditPopup"
      >
        <PencilThinIcon class="switcher-menu__icon" />
        {{ t('news_page_rubrics_switcher.button.edit') }}
      </ListItem>
      <ListItem
        item="delete"
        @click.stop="openDeletePopup"
      >
        <TrashIcon class="switcher-menu__icon" />
        {{ t('news_page_rubrics_switcher.button.delete') }}
      </ListItem>
      <ListItem
        v-if="!isFixedRubric && type === 'rubrics'"
        item="monitoring"
        @click="addToMonitoring"
      >
        <EyeIcon class="switcher-menu__icon" />
        {{ t('news_page_rubrics_switcher.button.monitoring') }}
      </ListItem>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.switcher-menu {
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9998;
    background: transparent;
  }

  &__list {
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 6px;
    border-radius: 8px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: var(--background-bg-white);
    box-shadow: 1px 2px 10px 0 #131E2726;
  }

  &__icon {
    width: 16px;
    height: 16px;
  }
}
</style>